
import React, { useState } from 'react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from './ui/dialog';

const TruncatedDescription = ({ description, maxLength = 100 }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!description) {
    return <p className="text-slate-500 mt-1">No description</p>;
  }

  if (description.length <= maxLength) {
    return <p className="text-slate-500 mt-1">{description}</p>;
  }

  const truncatedText = `${description.substring(0, maxLength)}...`;

  return (
    <div>
      <p className="text-slate-500 mt-1">{truncatedText}</p>
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogTrigger asChild>
          <Button variant="link" size="sm" className="px-0 h-auto text-violet-600 hover:text-violet-700">
            Read more
          </Button>
        </DialogTrigger>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Project Description</DialogTitle>
          </DialogHeader>
          <DialogDescription className="prose max-w-none">
            {description}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default TruncatedDescription;
